import { useTranslation } from 'react-i18next';

import { DHT_CLA_SETTINGS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import EditDHTClaSettingsForm from './components/EditDHTClaSettingsForm';

import useGenerateComponents from './hooks/useGenerateComponents';
import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import useGetTableData from './hooks/useGetTableData';

const DHTClaSettings = () => {
  const { t } = useTranslation('common', { keyPrefix: 'DHTClaSettings' });

  const { isLoading, mutate: generateComponents } = useGenerateComponents();
  const columns = useGetColumnDefs();
  const { data, isFetching } = useGetTableData();
  const { mutate: deleteItem } = useDeleteById(DHT_CLA_SETTINGS, [
    'DHTClaSettings',
    'list'
  ]);

  const onDeleteClick = (id) => {
    deleteItem(id);
  };

  return (
    <TableCRUDLayout
      FormComponent={EditDHTClaSettingsForm}
      rows={data}
      getRowId={(row) => row.dutyTypeDynClaId}
      loading={isFetching}
      columns={columns}
      confirmationTitle={t('confirmationTitle')}
      confirmationBody={t('confirmationBody')}
      onDeleteClick={onDeleteClick}
      hideCreateAction={true}
      additionalButtons={[
        {
          label: t('grid.actions.generate'),
          startIcon: <SettingsSuggestIcon />,
          onClick: generateComponents,
          disabled: isLoading
        }
      ]}
    />
  );
};

export default DHTClaSettings;
